export default "__VITE_ASSET__GKEg$MO5__"